<template>
  <a class="dropdown-item" :href="url">
    <div>
      <span>{{ titulo }}</span>
      <p>{{ descricao }}</p>
      <p>{{ data }}</p>
    </div>
  </a>
</template>

<script>
export default {
  name: 'NotificacaoItem',
  props: {
    titulo: String,
    descricao: String,
    data: String,
    url: String
  }
}
</script>

<style scoped>

</style>
